import { formatResourcePath } from 'src/utils/regex';
import { GeneralASError } from 'src/registry/types/axios';
import { MutationConfig } from 'src/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import axios from 'src/lib/axios';
import { WebhookEndpoint } from 'src/features/webhook-endpoints/utils/types';
import { WebhookEndpointSchemaValues } from 'src/features/webhook-endpoints/utils/formSchema';

const RESOURCE = '/webhooks/webhook-endpoints/';

type MutationFnType = typeof mutationFn;

const mutationFn = ({ ...data }: WebhookEndpointSchemaValues): Promise<WebhookEndpoint> => {
    return axios.post(formatResourcePath(RESOURCE), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateWebhookEndpoint };
